angular.module('dpw.services').factory('ElementPlaceholder', ['$window', function ($window) {

    var ElementPlaceholder = function (hostElement) {
        var hostRect = hostElement.getBoundingClientRect();

        this._placeholder = $window.document.createElement('div');
        this._placeholder.style.width = hostRect.width + 'px';
        this._placeholder.style.height = hostRect.height + 'px';
        this._placeholder.style.visibility = 'hidden';

        this.hide();
    };

    ElementPlaceholder.create = function (hostElement) {
        return new ElementPlaceholder(hostElement);
    };

    ElementPlaceholder.prototype.get = function () {
        return this._placeholder;
    };

    ElementPlaceholder.prototype.show = function () {
        $(this._placeholder).show();
    };

    ElementPlaceholder.prototype.hide = function () {
        $(this._placeholder).hide();
    };

    return ElementPlaceholder;

}]);